import React from "react";
import {
  StackedCarousel,
  ResponsiveContainer
} from "react-stacked-center-carousel";
import Fab from "@mui/material/Fab";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Slide } from "../../components/Slide";

const data = [
  {
    image: "/images/2026/Panellhnio2026.jpg",
    text: "Πανελλήνιο Πρωτάθλημα 2026",
    rank:"1η Θέση",
    id:"Panellhnio2026"
  },
  {
    image: "/images/2025/Panellhnio2025.jpg",
    text: "Πανελλήνιο Πρωτάθλημα 2025",
    rank:"1η Θέση",
    id:"Panellhnio2025"
  },
  {
    image: "/images/Panellhnio2024.jpg",
    text: "Πανελλήνιο Πρωτάθλημα 2024",
    rank:"1η Θέση",
    id:"Panellhnio2024"
  },
  {
    image: "/images/Panellhnio2023Diploma.jpg",
    text: "Πανελλήνιο Πρωτάθλημα 2023",    
    rank:"1η Θέση",
    id:"Panellhnio2023"
  },
  {
    image: "/images/Panellhnio2022.jpg",
    text: "Πανελλήνιο Πρωτάθλημα 2022",
    rank:"1η Θέση",
    id:"Panellhnio2022"
  },
  {
    image: "/images/Panellhnio2021.jpg",
    text: "Πανελλήνιο Πρωτάθλημα 2021",
    rank:"1η Θέση",
    id:"Panellhnio2021"
  }
];

const PanellhniaPrwtathlhmataCarousel = () => {
  const ref = React.useRef(StackedCarousel);
  return (
    <div className="mt-5 w-100 bg-transparent border-0" style={{backgroundColor:"transparent"}}>
      <div style={{ width: "100%",height:"400px" }}>
        <ResponsiveContainer
          carouselRef={ref}
          render={(width, carouselRef) => {
            return (
              <StackedCarousel
                ref={carouselRef}
                slideComponent={Slide}
                slideWidth={500}
                carouselWidth={width}
                data={data}
                maxVisibleSlide={5}
                disableSwipe
                customScales={[1, 0.85, 0.7, 0.55]}
                transitionTime={450}
                height={450}
              />
            );
          }}
        />
        <Fab
          className="card-button left"
          size="small"
          onClick={() => ref.current?.goBack()}
        >
          <KeyboardArrowLeftIcon style={{ fontSize: 30 }} />
        </Fab>
        <Fab
          className="card-button right"
          size="small"
          onClick={() => ref.current?.goNext()}
        >
          <KeyboardArrowRightIcon style={{ fontSize: 30 }} />
        </Fab>
      </div>
    </div>
  );
};

export default PanellhniaPrwtathlhmataCarousel;
